import React, { Component } from 'react'
import Localshop from './project/Localshop'
import Dev from './project/Dev'

export default class Uiproject_page extends Component {

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    tilte = () => {
        const pathname = this.props.location.pathname;
        const index = pathname.lastIndexOf('/');
        const fileName = pathname.substring(index + 1);
        return fileName
    }

    fun =() => {
        const pathname = this.props.location.pathname;
        const index = pathname.lastIndexOf('/');
        const fileName = pathname.substring(index + 1);
        if(fileName === "Local shop"){
            return <Localshop />
        }
        if(fileName === "Dev"){
            return <Dev />
        }
        else if(fileName === ""){
            return "404"
        }
    }
      
    render() {
        return (
            <div className="container-fluid px-sm-5 px-4 pt-5">
                <div className="row"  id="heading">
                    <p className="pt-4">
                        <span className="text-muted" style={{ letterSpacing: 2 }}>
                          CASE STUDY
                        </span>
                        <br />
                        <span className="display-4 fopri">{this.tilte()}</span>
                    </p>
                </div>
                {this.fun()}
            </div>
)
   }
}
